export default __webpack_public_path__ + "static/media/iSchoolPrimary_RGB_Black.90c7c0c1.svg";